import { create } from "zustand";
import { devtools } from "zustand/middleware";







const storeApi = (set) => ({

    isSidebarOpen: true,
    valorAcordion: false,


    toggleSidebar: () => {
        set(state => ({
            isSidebarOpen: !state.isSidebarOpen,
        }));
    },


    sidebarCerrado: () => {
        set({ isSidebarOpen: false });
    },


    
    toggleAcordion: (valor) => {
        set({ valorAcordion: valor })
    }



});




export const useSidebarStore = create()(
    devtools(
        storeApi
    )
)
